import React from "react";

interface IUndoIconProps extends React.SVGProps<SVGSVGElement> {
  onClick?: () => void;
  hoverBackground?: string;
}

export const UndoIcon: React.FC<IUndoIconProps> = (props: IUndoIconProps) => {
  const svg = (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox={props.viewBox ?? "0 0 24 24"}
      fill={props.fill ?? "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7H15C16.8692 7 17.8039 7 18.5 7.40193C18.9561 7.66523 19.3348 8.04394 19.5981 8.49999C20 9.19615 20 10.1308 20 12C20 13.8692 20 14.8038 19.5981 15.5C19.3348 15.9561 18.9561 16.3348 18.5 16.5981C17.8039 17 16.8692 17 15 17H8.00001M4 7L7 4M4 7L7 10"
        stroke={props.stroke ?? "#65656C"}
        strokeWidth={props.strokeWidth ?? "1.5"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
    </svg>
  );

  if (!props.onClick) return svg;

  return (
    <span
      role="button"
      aria-label="Undo"
      tabIndex={0}
      onClick={props.onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          props.onClick?.();
        }
      }}
      style={{
        display: "inline-flex",
        cursor: "pointer",
        padding: 2,
        borderRadius: 6,
        transition: "background 0.15s, box-shadow 0.15s",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = props.hoverBackground ?? "#f2f2f2";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
      }}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
      onBlur={(e) => {
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {svg}
    </span>
  );
};
